import { CircleCheck, CircleX, Info, TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";

import styles from "./Message.module.css";
import type { Tone } from "./status";

const ICONS = {
  neutral: Info,
  information: Info,
  success: CircleCheck,
  warning: TriangleAlert,
  danger: CircleX,
} as const;

type SectionProps = {
  tone?: Tone;
  title?: string;
  children?: ReactNode;
  actions?: ReactNode;
  className?: string;
};

export function SectionMessage({ tone = "information", title, children, actions, className }: SectionProps) {
  const Icon = ICONS[tone];
  return (
    <section
      className={[styles.section, styles[`section-${tone}`], className ?? ""].filter(Boolean).join(" ")}
      role={tone === "danger" ? "alert" : "status"}
    >
      <Icon size={16} strokeWidth={1.75} aria-hidden="true" className={styles.sectionIcon} />
      <div className={styles.sectionBody}>
        {title ? <p className={styles.sectionTitle}>{title}</p> : null}
        {children ? <div className={styles.sectionText}>{children}</div> : null}
        {actions ? <div className={styles.sectionActions}>{actions}</div> : null}
      </div>
    </section>
  );
}
